"use client";

import { useCallback, useEffect, useState } from "react";
import {
  Check,
  Gem,
  Headphones,
  PackagePlus,
  Rocket,
  Shield,
} from "lucide-react";
import { Card, CardContent } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
// import { Switch } from "../../components/ui/switch";
import MainBody from "../../components/MainBody/MainBody";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import { loadStripe } from "@stripe/stripe-js";
// import NumberFlow from "@number-flow/react";
import {
  API,
  fileUpload,
  get,
  onBoardingList,
  STRIPE_PUBLISHABLE_KEY,
} from "../../config";
import { useTrust } from "../../lib/context/TrustContext";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { formatNumber } from "../../lib/Misc";
import Confirmation from "../../components/Confirmation";
// import { Switch } from "../../components/ui/switch";
import { useLocation } from "react-router-dom";
// import { useUser } from "../../lib/context/UserContext";
import { AMLCTFModuleConditonIndustry } from "../../lib/PermissionConditions";
import { cn } from "../../lib/utils";
// import { Switch } from "../../components/ui/switch";

export default function PricingPlans({ expandList }) {
  const [selected, setSelected] = useState(null);

  const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
  const location = useLocation();
  const { state } = location;
  const query = new URLSearchParams(location.search);
  const defaultPlanType = query.get("plan_type");

  const [isOnBoard, setIsOnBoard] = useState(false);
  const [isAMLCTF, setIsAMLCTF] = useState(true);
  const [planIsMontly, setPlanIsMontly] = useState(false);
  // const [planIsKYB, setPlanIsKYB] = useState(false);
  const [isAddOn, setIsAddOn] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [billingCycle, setBillingCycle] = useState("main_plan");
  const [open, setOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [coupons, setCoupons] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [plans, setPlans] = useState();
  const [commonFeatures, setCommonFeature] = useState([]);
  const [amlCommonFeatures, setAmlCommonFeature] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [methodLoading, setMethodLoading] = useState([]);

  const [planListData, setPlanListData] = useState();
  const [addOnListData, setAddOnListData] = useState();

  const { trustId } = useTrust();
  // const { userData } = useUser();

  const [activePlan, setActivePlan] = useState(null);

  const { organizationData } = useOrganization();

  const [promptOnBoard, setPromptOnBoard] = useState(false);

  const [mode, setMode] = useState(defaultPlanType || "aml_ctf_plan"); // monthly | onboarding | aml_ctf_plan
  const [addonMode, setAddonMode] = useState(defaultPlanType || "kyc"); // monthly | onboarding | aml_ctf_plan

  const options =
    // userData?.email === "dchoradiya@gmail.com" &&
    AMLCTFModuleConditonIndustry(organizationData)
      ? [
          { key: "onboarding", label: "Onboarding" },
          { key: "main_plan", label: "Trust Plans" },
          { key: "aml_ctf_plan", label: "AML / CTF Plans" },
        ]
      : [
          { key: "onboarding", label: "Onboarding" },
          { key: "main_plan", label: "Trust Plans" },
        ];

  const addonOPtions =
    // userData?.email === "dchoradiya@gmail.com" &&
    AMLCTFModuleConditonIndustry(organizationData)
      ? [
          { key: "kyc", label: "KYC" },
          { key: "kyb", label: "KYB" },
          { key: "user", label: "USER" },
        ]
      : [];

  const togglePromptOnBoard = () => {
    setPromptOnBoard(!promptOnBoard);
  };

  const fetchBillingData = useCallback(async () => {
    try {
      setLoading2(true);
      const formData = new FormData();
      formData.append("organization_id", organizationData?.organizationId);
      const activeRes = await fileUpload(
        API.GET_SUBSCRIPTION_DETAILS,
        formData,
      );
      const active = {
        amlCtfSubscription:
          activeRes.data?.data?.amlCtfSubscription[0]?.status !== "canceled"
            ? activeRes.data?.data?.amlCtfSubscription[0]
            : "",
        subscription:
          activeRes.data?.data?.subscriptions[0]?.status !== "canceled"
            ? activeRes.data?.data?.subscriptions[0]
            : "",
        support_plan: activeRes.data?.data?.supportPlan,
      };
      setActivePlan(active);
      setLoading2(false);
    } catch (e) {
      setLoading2(false);
    }
  }, [organizationData?.organizationId]);

  useEffect(() => {
    fetchBillingData();
  }, [fetchBillingData]);

  const fetchPaymentMethods = useCallback(async () => {
    try {
      setMethodLoading(true);
      const formData = new FormData();
      formData.append("organization_id", organizationData?.organizationId);
      const activeRes = await fileUpload(API.GET_PAYMENT_METHODS, formData);
      const active = activeRes.data?.data;
      setPaymentMethod(active);
      setMethodLoading(false);
    } catch (e) {
      setMethodLoading(false);
    }
  }, [organizationData?.organizationId]);

  useEffect(() => {
    fetchPaymentMethods();
  }, [fetchPaymentMethods]);

  const handleSubscribe = async (plan, addon = false) => {
    setSelectedPlan(plan);
    setOpen(true);
    setIsAddOn(addon);
  };

  const fetchStripProducts = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await get(
        `${API.STRIPE_PRODUCTS}${organizationData?.organizationId ? `?organization_id=${organizationData?.organizationId}` : ""}`,
      );

      const planList = data.data;

      // Aml Month Plan Array
      let amlMonthly = planList?.plans?.filter(
        (item) => item?.metadata?.interval === "aml_monthly",
      );

      let amlMonthlyPlan = [];

      for (let monthIndex = 0; monthIndex < amlMonthly?.length; monthIndex++) {
        let activePrice = amlMonthly[monthIndex]?.prices?.data?.find(
          (item) => item.active === true,
        );
        let planMonth = {
          ...amlMonthly[monthIndex],
          id: amlMonthly[monthIndex]?.id,
          name: amlMonthly[monthIndex]?.metadata?.name,
          price: activePrice?.unit_amount / 100,
          plan: activePrice,
          amount: activePrice?.unit_amount,
          trusts: amlMonthly[monthIndex]?.metadata?.trust
            ? amlMonthly[monthIndex]?.metadata?.trust
            : 1,
        };
        amlMonthlyPlan.push(planMonth);
      }

      // AML Year Plan Array
      let amlYearly = planList?.plans?.filter(
        (item) => item?.metadata?.interval === "aml_yearly",
      );

      let amlYearlyPlan = [];

      for (let yearIndex = 0; yearIndex < amlYearly?.length; yearIndex++) {
        let activePrice = amlYearly[yearIndex]?.prices?.data?.find(
          (item) => item.active === true,
        );
        let planYear = {
          ...amlYearly[yearIndex],
          id: amlYearly[yearIndex]?.id,
          name: amlYearly[yearIndex]?.metadata?.name,
          price: activePrice?.unit_amount / 100,
          plan: activePrice,
          amount: activePrice?.unit_amount,
          trusts: amlYearly[yearIndex]?.metadata?.trust
            ? amlYearly[yearIndex]?.metadata?.trust
            : 1,
        };
        amlYearlyPlan.push(planYear);
      }

      // Month Plan Array
      let monthly = planList?.plans?.filter(
        (item) => item?.metadata?.interval === "monthly",
      );

      let monthlyPlan = [];

      for (let monthIndex = 0; monthIndex < monthly?.length; monthIndex++) {
        let activePrice = monthly[monthIndex]?.prices?.data?.find(
          (item) => item.active === true,
        );
        let planMonth = {
          ...monthly[monthIndex],
          id: monthly[monthIndex]?.id,
          name: monthly[monthIndex]?.metadata?.name,
          price: activePrice?.unit_amount / 100,
          plan: activePrice,
          amount: activePrice?.unit_amount,
          trusts: monthly[monthIndex]?.metadata?.trust
            ? monthly[monthIndex]?.metadata?.trust
            : 1,
        };
        monthlyPlan.push(planMonth);
      }

      // Year Plan Array
      let yearly = planList?.plans?.filter(
        (item) => item?.metadata?.interval === "yearly",
      );

      let yearlyPlan = [];

      for (let yearIndex = 0; yearIndex < yearly?.length; yearIndex++) {
        let activePrice = yearly[yearIndex]?.prices?.data?.find(
          (item) => item.active === true,
        );
        let planYear = {
          ...yearly[yearIndex],
          id: yearly[yearIndex]?.id,
          name: yearly[yearIndex]?.metadata?.name,
          price: activePrice?.unit_amount / 100,
          plan: activePrice,
          amount: activePrice?.unit_amount,
          trusts: yearly[yearIndex]?.metadata?.trust
            ? yearly[yearIndex]?.metadata?.trust
            : 1,
        };
        yearlyPlan.push(planYear);
      }

      // Onboarding Plan Array
      let onboard = planList?.supportPlans;

      let activePrice = onboard?.prices?.data?.find(
        (item) => item.active === true,
      );
      let onboardPlan = {
        ...onboard,
        id: onboard?.id,
        name: onboard?.metadata?.name,
        price: activePrice?.unit_amount / 100,
        marketing_features: onBoardingList,
        plan: activePrice,
        amount: activePrice?.unit_amount,
        trusts: onboard?.metadata?.trust ? onboard?.metadata?.trust : 1,
      };

      const commonList = monthlyPlan
        .map((item) => item.marketing_features.map((f) => f.name)) // extract names array from each item
        .reduce((acc, curr) => acc.filter((name) => curr.includes(name)));

      const amlCommonList =
        amlMonthlyPlan?.length > 0
          ? amlMonthlyPlan
              .map((item) => item.marketing_features.map((f) => f.name)) // extract names array from each item
              .reduce((acc, curr) => acc.filter((name) => curr.includes(name)))
          : [];

      // KYC ADDON Plan
      let addOnKYCPlanData = planList?.addOns?.filter(
        (item) => item?.metadata?.interval === "aml_add_on_kyc",
      );

      let addOnKYCPlans = [];

      for (
        let addonKYCIndex = 0;
        addonKYCIndex < addOnKYCPlanData?.length;
        addonKYCIndex++
      ) {
        let activePrice = addOnKYCPlanData[addonKYCIndex]?.prices?.data?.filter(
          (item) => item.active === true,
        );
        for (
          let addonIndex = 0;
          addonIndex < activePrice?.length;
          addonIndex++
        ) {
          let planMonth = {
            ...addOnKYCPlanData[addonKYCIndex],
            product_id: addOnKYCPlanData[addonKYCIndex]?.id,
            id: activePrice[addonIndex]?.id,
            price_data: activePrice[addonIndex],
            name: activePrice[addonIndex]?.metadata?.name,
            price: activePrice[addonIndex]?.unit_amount / 100,
            plan: addOnKYCPlanData[addonKYCIndex],
            amount: activePrice[addonIndex]?.unit_amount,
            title: activePrice?.[addonIndex]?.metadata?.title
              ? activePrice?.[addonIndex]?.metadata?.title
              : 1,
            description: activePrice?.[addonIndex]?.metadata?.description
              ? activePrice?.[addonIndex]?.metadata?.description
              : 1,
          };
          addOnKYCPlans.push(planMonth);
        }
      }

      // KYB ADDON Plan
      let addOnKYBPlanData = planList?.addOns?.filter(
        (item) => item?.metadata?.interval === "aml_add_on_kyb",
      );

      let addOnKYBPlans = [];

      for (
        let addonKYBIndex = 0;
        addonKYBIndex < addOnKYBPlanData?.length;
        addonKYBIndex++
      ) {
        let activePrice = addOnKYBPlanData[addonKYBIndex]?.prices?.data?.filter(
          (item) => item.active === true,
        );
        for (
          let addonIndex = 0;
          addonIndex < activePrice?.length;
          addonIndex++
        ) {
          let planMonth = {
            ...addOnKYBPlanData[addonKYBIndex],
            product_id: addOnKYBPlanData[addonKYBIndex]?.id,
            id: activePrice[addonIndex]?.id,
            price_data: activePrice[addonIndex],
            name: activePrice[addonIndex]?.metadata?.name,
            price: activePrice[addonIndex]?.unit_amount / 100,
            plan: addOnKYBPlanData[addonKYBIndex],
            amount: activePrice[addonIndex]?.unit_amount,
            title: activePrice?.[addonIndex]?.metadata?.title
              ? activePrice?.[addonIndex]?.metadata?.title
              : 1,
            description: activePrice?.[addonIndex]?.metadata?.description
              ? activePrice?.[addonIndex]?.metadata?.description
              : 1,
          };
          addOnKYBPlans.push(planMonth);
        }
      }

      // User ADDON Plan
      let addOnUserPlanData = planList?.addOns?.filter(
        (item) => item?.metadata?.interval === "aml_add_on_user",
      );

      let addOnUserPlans = [];

      for (
        let addonUserIndex = 0;
        addonUserIndex < addOnUserPlanData?.length;
        addonUserIndex++
      ) {
        let activePrice = addOnUserPlanData[
          addonUserIndex
        ]?.prices?.data?.filter((item) => item.active === true);
        for (
          let addonIndex = 0;
          addonIndex < activePrice?.length;
          addonIndex++
        ) {
          let planMonth = {
            ...addOnUserPlanData[addonUserIndex],
            product_id: addOnUserPlanData[addonUserIndex]?.id,
            id: activePrice[addonIndex]?.id,
            price_data: activePrice[addonIndex],
            name: activePrice[addonIndex]?.metadata?.name,
            price: activePrice[addonIndex]?.unit_amount / 100,
            plan: addOnUserPlanData[addonUserIndex],
            amount: activePrice[addonIndex]?.unit_amount,
            title: activePrice?.[addonIndex]?.metadata?.title
              ? activePrice?.[addonIndex]?.metadata?.title
              : 1,
            description: activePrice?.[addonIndex]?.metadata?.description
              ? activePrice?.[addonIndex]?.metadata?.description
              : 1,
          };
          addOnUserPlans.push(planMonth);
        }
      }

      setPlans({
        main_plan: {
          monthly:
            monthlyPlan?.length > 0
              ? monthlyPlan.sort((a, b) => a.price - b.price)
              : [],
          yearly:
            yearlyPlan?.length > 0
              ? yearlyPlan.sort((a, b) => a.price - b.price)
              : [],
        },
        aml_ctf_plan: {
          monthly:
            amlMonthlyPlan?.length > 0
              ? amlMonthlyPlan.sort((a, b) => a.price - b.price)
              : [],
          yearly:
            amlYearlyPlan?.length > 0
              ? amlYearlyPlan.sort((a, b) => a.price - b.price)
              : [],
        },
        onboard: [onboardPlan],
        addon: {
          kyc: addOnKYCPlans,
          kyb: addOnKYBPlans,
          user: addOnUserPlans,
        },
      });

      let planDatas = {
        main_plan: {
          monthly: monthlyPlan.sort((a, b) => a.price - b.price),
          yearly: yearlyPlan.sort((a, b) => a.price - b.price),
        },
        aml_ctf_plan: {
          monthly: amlMonthlyPlan.sort((a, b) => a.price - b.price),
          yearly: amlYearlyPlan.sort((a, b) => a.price - b.price),
        },
        onboard: [onboardPlan],
        addon: {
          kyc: addOnKYCPlans.sort((a, b) => a.price - b.price),
          kyb: addOnKYBPlans.sort((a, b) => a.price - b.price),
          user: addOnUserPlans.sort((a, b) => a.price - b.price),
        },
      };      

      if ((state?.planType && state?.planType === "AML/CTF") || isAMLCTF) {
        setIsOnBoard(false);
        setIsAMLCTF(true);
        setMode("aml_ctf_plan");
        setPlanIsMontly(true);
        setPlanListData(planDatas?.["aml_ctf_plan"]?.["yearly"]);
        setBillingCycle("aml_ctf_plan");
      } else {
        setPlanListData(
          planIsMontly
            ? planDatas?.[mode]?.["yearly"]
            : planDatas?.[mode]?.["monthly"],
        );
      }

      setAddOnListData(planDatas?.["addon"]?.[addonMode]);
      setAddonMode(addonMode);

      setCoupons(planList?.coupons);
      setCommonFeature(commonList);
      setAmlCommonFeature(amlCommonList);

      setLoading(false);
      // setModulesList(modulesList);
      return data.data;
    } catch (error) {
      setLoading(false);
      // setModulesList([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchStripProducts();
  }, [fetchStripProducts]);

  return (
    <MainBody
      search={false}
      actionContent={""}
      loading={loading || loading2 || methodLoading}
      className={expandList ? "bg-secondary p-0 rounded-lg" : "bg-secondary"}
      expandList={expandList}
    >
      <div className="max-w-6xl mx-auto py-4 px-4">
        {/* <h2 className="text-3xl font-bold text-center mb-8">Plans</h2> */}

        <div className="flex items-center justify-center mt-2 mb-8">
          <div className="flex rounded-full p-1 bg-webPrimary">
            {options.map((opt) => (
              <div
                key={opt.key}
                onClick={() => {
                  setMode(opt.key);
                  if (opt.key === "onboarding") {
                    setIsOnBoard(true);
                    setIsAMLCTF(false);
                    setPlanListData(plans?.["onboard"]);
                    setBillingCycle("onboard");
                  } else if (opt.key === "aml_ctf_plan") {
                    setIsOnBoard(false);
                    setIsAMLCTF(true);
                    setPlanIsMontly(true);
                    // setPlanListData(
                    //   plans?.["aml_ctf_plan"]?.[
                    //     planIsMontly ? "yearly" : "monthly"
                    //   ]
                    // );
                    setPlanListData(plans?.["aml_ctf_plan"]?.["yearly"]);
                    setBillingCycle("aml_ctf_plan");
                  } else {
                    setIsAMLCTF(false);
                    setIsOnBoard(false);
                    // setPlanListData(
                    //   plans?.["main_plan"]?.[
                    //     planIsMontly ? "yearly" : "monthly"
                    //   ],
                    // );
                    setPlanIsMontly(false);
                    setPlanListData(plans?.["main_plan"]?.["monthly"]);
                    setBillingCycle("main_plan");
                  }
                }}
                className={`
              relative cursor-pointer px-5 py-2 rounded-full text-sm font-medium
              transition-all duration-200 flex items-center space-x-2
              ${
                mode === opt.key
                  ? "bg-white shadow-md text-black"
                  : "text-white"
              }
            `}
              >
                <span>{opt.label}</span>

                {opt.badge && (
                  <span className="text-[10px] bg-black text-white px-2 py-0.5 rounded">
                    {opt.badge}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* {!isOnBoard && (
          <div className="flex items-center justify-center space-x-2 mb-8">
            <span
              className="text-sm font-medium cursor-pointer"
              onClick={() => {
                setPlanIsMontly(false);
                setPlanListData(plans?.[billingCycle]?.["monthly"]);
              }}
            >
              Monthly
            </span>
            <Switch
              checked={planIsMontly}
              onCheckedChange={(e) => {
                if (e === true) {
                  setPlanIsMontly(true);
                  setPlanListData(plans?.[billingCycle]?.["yearly"]);
                } else {
                  setPlanIsMontly(false);
                  setPlanListData(plans?.[billingCycle]?.["monthly"]);
                }
              }}
              className="data-[state=checked]:bg-webPrimary"
            />
            <span
              className="text-sm font-medium cursor-pointer"
              onClick={() => {
                setPlanIsMontly(true);
                setPlanListData(plans?.[billingCycle]?.["yearly"]);
              }}
            >
              Yearly
            </span>
          </div>
        )} */}
        <div
          className={`grid grid-cols-1 place-items-center gap-6 mb-10 ${
            planListData?.length >= 3
              ? "md:grid-cols-3"
              : planListData?.length === 2
                ? "md:grid-cols-2"
                : "md:grid-cols-1"
          }`}
        >
          {planListData?.length > 0 &&
            planListData.map((plan) => {
              const planType = plan.name.toLowerCase();

              let icon = Gem;
              let highlight = "";
              let styles = {
                border: "border-gray-300",
                text: "text-gray-800",
                bg: "bg-gray-800",
                disable: "bg-gray-900 cursor-not-allowed",
                hover: "hover:bg-gray-900",
                badge: "bg-gray-500",
              };

              if (
                planType.includes("professional") ||
                planType.includes("pro")
              ) {
                icon = Shield;
                styles = {
                  border: "border-green-500",
                  text: "text-green-600",
                  bg: "bg-green-600",
                  disable: "bg-green-900 cursor-not-allowed",
                  hover: "hover:bg-green-700",
                  badge: "bg-green-500",
                };
              } else if (
                planType.includes("hybrid") ||
                planType.includes("high")
              ) {
                icon = Rocket;
                highlight = "Most Popular";
                styles = {
                  border: "border-blue-500",
                  text: "text-blue-600",
                  bg: "bg-blue-600",
                  disable: "bg-blue-900 cursor-not-allowed",
                  hover: "hover:bg-blue-700",
                  badge: "bg-blue-500",
                };
              } else if (planType.includes("ultimate")) {
                icon = Gem;
                styles = {
                  border: "border-purple-500",
                  text: "text-purple-600",
                  bg: "bg-purple-600",
                  disable: "bg-purple-900 cursor-not-allowed",
                  hover: "hover:bg-purple-700",
                  badge: "bg-purple-500",
                };
              } else if (planType.includes("onboarding")) {
                icon = Headphones;
                styles = {
                  border: "border-webPrimary",
                  text: "text-webPrimary",
                  bg: "bg-webPrimary",
                  disable: "bg-webSecondary cursor-not-allowed",
                  hover: "hover:bg-webSecondary",
                  badge: "bg-webPrimary",
                };
              }

              const Icon = icon;

              return (
                <Card
                  key={plan.name}
                  className={`${
                    planListData?.length === 2
                      ? "min-w-[100%]"
                      : planListData?.length === 1
                        ? "min-w-[33%]"
                        : "min-w-[100%]"
                  } 
          hover:cursor-pointer dark:bg-background relative shadow-md border p-6 flex flex-col justify-between transform transition-all duration-300 hover:scale-105 hover:-translate-y-1 hover:shadow-2xl ${
            styles.border
          }`}
                >
                  {(highlight ||
                    activePlan?.support_plan?.price_id === plan?.plan?.id ||
                    activePlan?.subscription?.price_id === plan?.plan?.id ||
                    activePlan?.amlCtfSubscription?.price_id ===
                      plan?.plan?.id) && (
                    <div
                      className={`absolute -top-3 right-4 ${styles.badge} text-white text-xs px-2 py-1 rounded-full shadow-sm`}
                    >
                      {activePlan?.support_plan?.price_id === plan?.plan?.id ||
                      activePlan?.subscription?.price_id === plan?.plan?.id ||
                      activePlan?.amlCtfSubscription?.price_id ===
                        plan?.plan?.id
                        ? "Active Plan"
                        : highlight}
                    </div>
                  )}
                  <CardContent className="p-0 space-y-4">
                    <div
                      className={`flex items-center gap-2 mb-2 ${styles.text}`}
                    >
                      <Icon className="w-6 h-6" />
                      <h3 className="text-xl font-semibold">{plan.name}</h3>
                    </div>
                    {/* <p className="text-sm">
                    {plan.trusts} Trust{plan.trusts > 1 ? "s" : ""}
                  </p> */}
                    <p className="text-4xl font-bold">
                      {/* <NumberFlow
                      value={plan.price}
                      format={{
                        style: "currency",
                        currency: "USD",
                        trailingZeroDisplay: "stripIfInteger",
                      }}
                      // suffix={isOnBoard ? "/yr" : "/m"}
                    /> */}
                      {plan.price ? `$${formatNumber(plan.price)}` : "$0.00"}
                      <span className="text-xl font-semibold">
                        {isOnBoard ? "" : planIsMontly ? "/y" : "/m"}
                        <span className="text-sm"> (Ex. GST)</span>
                      </span>
                    </p>
                    <Button
                      className={`w-full ${styles.bg} ${styles.hover} ${
                        isOnBoard &&
                        activePlan?.support_plan?.price_id === plan?.plan?.id
                          ? styles.disable
                          : activePlan?.subscription?.price_id ===
                              plan?.plan?.id
                            ? styles.disable
                            : ""
                      }`}
                      onClick={() => handleSubscribe(plan)}
                      disabled={
                        isOnBoard &&
                        activePlan?.support_plan?.price_id === plan?.plan?.id
                          ? true
                          : activePlan?.subscription?.price_id ===
                              plan?.plan?.id
                            ? true
                            : activePlan?.amlCtfSubscription?.price_id ===
                                plan?.plan?.id
                              ? true
                              : isAMLCTF && plan?.custom_tier === 1
                                ? true
                                : false
                      }
                    >
                      {/* {isOnBoard &&
                      activePlan?.support_plan?.price_id === plan?.plan?.id
                        ? "Current"
                        : activePlan?.subscription?.price_id === plan?.plan?.id
                          ? "Current"
                          : activePlan?.amlCtfSubscription?.price_id ===
                              plan?.plan?.id
                            ? "Current"
                            : "Subscribe"} */}
                      {isOnBoard &&
                      activePlan?.support_plan?.price_id === plan?.plan?.id
                        ? "Current"
                        : plan?.custom_tier === 2
                          ? "Current"
                          : plan?.custom_tier === 1
                            ? "Downgrade"
                            : plan?.custom_tier === 3
                              ? "Upgrade"
                              : "Subscribe"}
                    </Button>

                    <div className="mt-6">
                      <p className="font-medium mb-2">This plan includes:</p>
                      <ul className="space-y-2 text-sm text-muted-foreground">
                        {plan?.marketing_features?.find((item) =>
                          item.name?.includes("heading:"),
                        ) ? (
                          <>
                            <div
                              className={`grid grid-cols-${
                                plan?.marketing_features?.filter((f) =>
                                  f?.name?.includes("heading:"),
                                ).length
                              }`}
                            >
                              {plan?.marketing_features
                                ?.map((feature, idx) => ({ feature, idx }))
                                .filter(({ feature }) =>
                                  feature.name.includes("heading:"),
                                )
                                .map(({ feature, idx }, colIndex, headings) => {
                                  const nextHeadingIdx =
                                    headings[colIndex + 1]?.idx ??
                                    plan.marketing_features.length;

                                  const columnItems =
                                    plan.marketing_features.slice(
                                      idx + 1,
                                      nextHeadingIdx,
                                    );

                                  return (
                                    <ul key={idx} className="space-y-2 text-sm">
                                      {/* Heading */}
                                      <li className="font-bold text-xl text-webPrimary">
                                        {feature.name.split("heading:")[1]}
                                      </li>

                                      {/* Items under this heading */}
                                      {columnItems.map((item, i) =>
                                        item.name.includes("label:") ? (
                                          <li
                                            key={i}
                                            className="font-semibold text-webPrimary"
                                          >
                                            {item.name.split("label:")[1]}
                                          </li>
                                        ) : (
                                          !commonFeatures?.includes(
                                            item.name,
                                          ) &&
                                          !amlCommonFeatures?.includes(
                                            item.name,
                                          ) && (
                                            <li
                                              key={i}
                                              className="flex items-center gap-2 pl-2"
                                            >
                                              <Check className="w-4 h-4 text-green-600" />
                                              {item.name}
                                            </li>
                                          )
                                        ),
                                      )}
                                    </ul>
                                  );
                                })}
                            </div>
                          </>
                        ) : (
                          plan?.marketing_features?.map((feature, idx) =>
                            feature?.name?.includes("label:") ? (
                              <li
                                key={idx}
                                className="flex items-center gap-2 font-bold text-webPrimary"
                              >
                                {feature?.name?.split("label:")[1]}
                              </li>
                            ) : (
                              !commonFeatures?.includes(feature?.name) &&
                              !amlCommonFeatures?.includes(feature?.name) && (
                                <li
                                  key={idx}
                                  className="flex items-center gap-2"
                                >
                                  <Check className="w-4 h-4 text-green-600" />
                                  {feature?.name}
                                </li>
                              )
                            ),
                          )
                        )}
                      </ul>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
        </div>

        {!isOnBoard && !isAMLCTF && commonFeatures?.length > 0 && (
          <div className="bg-background rounded-lg p-6 shadow-md border">
            <h4 className="text-lg font-semibold mb-4">All plans include</h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 text-sm text-muted-foreground">
              {commonFeatures?.map((feature, idx) => (
                <div key={idx} className="flex items-center gap-2">
                  <Check className="w-4 h-4 text-green-600" />
                  {feature}
                </div>
              ))}
            </div>
          </div>
        )}

        {!isOnBoard && isAMLCTF && amlCommonFeatures?.length > 0 && (
          <div className="bg-background rounded-lg p-6 shadow-md border">
            <h4 className="text-lg font-semibold mb-4">All plans include</h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 text-sm text-muted-foreground">
              {amlCommonFeatures?.map((feature, idx) => (
                <div key={idx} className="flex items-center gap-2">
                  <Check className="w-4 h-4 text-green-600" />
                  {feature}
                </div>
              ))}
            </div>
          </div>
        )}

        {isAMLCTF && (
          <div className="w-full max-w-6xl mx-auto mt-6">
            <div className="border rounded-2xl p-8 bg-white shadow-sm relative">
              {/* <div className="flex items-center justify-center space-x-2 top-8 left-[47%] absolute">
                <span
                  className="text-sm font-medium cursor-pointer"
                  onClick={() => {
                    setPlanIsKYB(false);
                    setAddOnListData(plans?.["addon"]?.["kyc"]);
                    setSelected(null);
                  }}
                >
                  KYC
                </span>
                <Switch
                  checked={planIsKYB}
                  onCheckedChange={(e) => {
                    if (e === true) {
                      setPlanIsKYB(true);
                      setAddOnListData(plans?.["addon"]?.["kyb"]);
                      setSelected(null);
                    } else {
                      setPlanIsKYB(false);
                      setAddOnListData(plans?.["addon"]?.["kyc"]);
                      setSelected(null);
                    }
                  }}
                  className="data-[state=checked]:bg-webPrimary"
                />
                <span
                  className="text-sm font-medium cursor-pointer"
                  onClick={() => {
                    setPlanIsKYB(false);
                    setAddOnListData(plans?.["addon"]?.["kyb"]);
                    setSelected(null);
                  }}
                >
                  KYB
                </span>
              </div> */}

              <div className="flex items-center justify-center top-4 left-[40%] absolute">
                <div className="flex rounded-full p-1 bg-webPrimary">
                  {addonOPtions.map((opt) => (
                    <div
                      key={opt.key}
                      onClick={() => {
                        setAddonMode(opt.key);
                        if (opt.key === "kyc") {
                          setAddOnListData(plans?.["addon"]?.["kyc"]);
                          setSelected(null);
                        } else if (opt.key === "kyb") {
                          setAddOnListData(plans?.["addon"]?.["kyb"]);
                          setSelected(null);
                        } else if (opt.key === "user") {
                          setAddOnListData(plans?.["addon"]?.["user"]);
                          setSelected(null);
                        } else {
                          setSelected(null);
                        }
                      }}
                      className={`relative cursor-pointer px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 flex items-center space-x-2 
                        ${
                          addonMode === opt.key
                            ? "bg-white shadow-md text-black"
                            : "text-white"
                        } 
                      `}
                    >
                      <span>{opt.label}</span>
                      {opt.badge && (
                        <span className="text-[10px] bg-black text-white px-2 py-0.5 rounded">
                          {opt.badge}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Header */}
              <div className="flex justify-between items-start mb-8">
                <div>
                  <h2 className="text-2xl font-semibold mb-2">
                    Additional add-ons
                  </h2>
                  <p className="text-muted-foreground text-sm mb-2">
                    AML CTF CDD/KYC Add Ons (Individual Checks) including DVS,
                    Bureau, PEP and Sanction Checks
                  </p>
                  <p className="text-muted-foreground text-sm">
                    {/* Please choose your ID‑check add-on carefully. Any unused ID
                    checks will expire at the end of your subscription period of
                    AML CTF annual plan and will not roll over to the next
                    billing cycle. */}
                    All the add-on plans expire with the annual plan and don't roll over
                  </p>
                </div>

                {/* <div className="w-12 h-12 bg-black rounded-md" /> */}
                <PackagePlus className="w-12 h-12" />
              </div>

              {/* Addons Grid */}
              <div className={`grid grid-cols-1 md:grid-cols-${addOnListData?.length} gap-6`}>
                {addOnListData?.map((addon) => {
                  const isSelected = selected === addon.id;

                  return (
                    <Card
                      key={addon.id}
                      onClick={() => setSelected(addon.id)}
                      className={cn(
                        "cursor-pointer rounded-xl border transition-all duration-200",
                        "hover:shadow-md hover:scale-[1.02]",
                        isSelected
                          ? "border-webPrimary ring-2 ring-webPrimary/20 bg-webPrimary/5"
                          : "bg-muted/40",
                      )}
                    >
                      <CardContent className="p-6 flex flex-col justify-between h-full">
                        {/* Top Content */}
                        <div>
                          <div className="flex items-start justify-between">
                            <h3 className="font-medium text-lg">
                              {addon.title}
                            </h3>

                            {/* Radio Indicator */}
                            <div
                              className={cn(
                                "w-5 h-5 rounded-full border flex items-center justify-center",
                                isSelected
                                  ? "border-webPrimary bg-webPrimary text-white"
                                  : "border-muted-foreground",
                              )}
                            >
                              {isSelected && <Check size={14} />}
                            </div>
                          </div>

                          <p className="text-sm text-muted-foreground mt-2 mb-6">
                            {addon.description}
                          </p>
                        </div>

                        {/* Bottom Content */}
                        <div className="flex items-center justify-between">
                          {/* Price */}
                          <div>
                            {addon.custom ? (
                              <p className="text-sm font-medium">
                                Contact Sales
                              </p>
                            ) : (
                              <p className="text-4xl font-bold">
                                {addon.price
                                  ? `$${formatNumber(addon.price)}`
                                  : "$0.00"}
                                <span className="text-sm"> (Ex. GST)</span>
                              </p>
                            )}
                          </div>

                          {/* Add Button */}
                          {/* <Button
                            size="sm"
                            variant={isSelected ? "default" : "outline"}
                          >
                            {isSelected ? "Added" : "Add"}
                          </Button> */}
                        </div>
                      </CardContent>
                    </Card>
                  );
                })}
              </div>

              {/* Selected Summary */}
              {selected && (
                <div className="mt-6 flex items-center justify-between w-full">
                  <div className="text-sm text-muted-foreground">
                    Selected:{" "}
                    <span className="font-medium text-foreground">
                      {addOnListData.find((a) => a.id === selected)?.title}
                    </span>
                  </div>
                  <Button
                    onClick={() =>
                      handleSubscribe(
                        addOnListData?.find((a) => a?.id === selected),
                        true,
                      )
                    }
                    className={"text-xl"}
                  >
                    Purchase
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Complete your purchase</DialogTitle>
          </DialogHeader>
          <Elements stripe={stripePromise}>
            <CheckoutForm
              plan={selectedPlan}
              coupons={coupons}
              trustId={trustId}
              currentSub={activePlan}
              updateSubscription={false}
              setOpen={setOpen}
              isOnBoard={isOnBoard}
              isAMLCTF={isAMLCTF}
              fetchStripProducts={fetchStripProducts}
              fetchBillingData={fetchBillingData}
              paymentMethods={paymentMethod}
              setPromptOnBoard={setPromptOnBoard}
              isAddOn={isAddOn}
              selected={addOnListData?.find((a) => a.id === selected)}
            />
          </Elements>
        </DialogContent>
      </Dialog>
      <Confirmation
        title={"Onboarding Plan"}
        open={promptOnBoard}
        setOpen={setPromptOnBoard}
        toggleShow={() => {
          togglePromptOnBoard();
        }}
        className="sm:max-w-1/2"
        message={"Would you like to add Onboarding Plan?"}
        okAction={async () => {
          setMode("onboarding");
          setIsOnBoard(true);
          setPlanListData(plans?.["onboard"]);
          setBillingCycle("onboard");
          togglePromptOnBoard();
        }}
        cancelAction={() => {
          setPromptOnBoard(false);
        }}
      />
    </MainBody>
  );
}
